import {
  ChangeDetectorRef,
  Component,
  Inject,
  Injector,
  OnInit,
  ViewEncapsulation,
} from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { Router } from "@angular/router";
import { ApiService } from "src/app/core/services/shared/api.service";
import { GlobalVarService } from "src/app/core/services/shared/global-var.service";
import { NotificationService } from "src/app/core/services/shared/notification.service";
import { environment } from "src/environments/environment";
import { CodehelpService, LoginInfo } from "virtue-form";
import { TuiDialogService } from "@taiga-ui/core";
import { ResultNotepopupComponent } from "../../shared/dialog/result-notepopup/result-notepopup.component";
import { PolymorpheusComponent } from "@tinkoff/ng-polymorpheus";
import { DemoUserIntroComponent } from "../../shared/dialog/demo-user-intro/demo-user-intro.component";
import { CheckLoginSessionService } from "src/app/core/services/shared/check-login-session.service";
import { take } from "rxjs/operators";

@Component({
  selector: "app-headertop5",
  templateUrl: "./headertop5.component.html",
  styleUrls: ["./headertop5.component.scss"],
  encapsulation: ViewEncapsulation.None,
})
export class Headertop5Component implements OnInit {
  popupexpired: any;
  imageURL = "";
  user = "";
  hide = true;
  navbarcss = "";
  links: any = [];
  containerCss = "container-fluid";
  logowithtxt: boolean = false;
  formlogin: FormGroup;
  signUp: FormGroup;
  logowithtxtHTML: string = "";
  topheaderbanner: boolean = false;
  topheaderbannerHTMl: string = "";

  IsLoadData: boolean = false;
  isLoginModelShow: boolean = false;
  isSignUpModelShow: boolean = false;

  logoURL: string = environment.logoURL;
  erroeMsg: string = "";
  basepath = "";
  signupMemeber = [
    {
      value: "1",
      label: "Counselor",
    },
    {
      value: "2",
      label: "Student",
    },
  ];

  constructor(
    private cdRef: ChangeDetectorRef,
    private checkloginSession: CheckLoginSessionService,
    private apiService: ApiService,
    public globalvar: GlobalVarService,
    private codehelp: CodehelpService,
    private router: Router,
    private notificatioService: NotificationService,
    @Inject(TuiDialogService) private readonly dialogService: TuiDialogService,
    @Inject(Injector) private readonly injector: Injector
  ) {
    this.formlogin = new FormGroup({
      user: new FormControl("", [Validators.required]),
      pass: new FormControl("", [Validators.required]),
    });
    this.signUp = new FormGroup({
      user: new FormControl("", [Validators.required]),
      pass: new FormControl("", [Validators.required]),
      userType: new FormControl(["Counselor", Validators.required]),
    });
    this.logoURL = environment.logoURL;
    this.basepath = this.globalvar.basepath;

    if (
      this.globalvar?.top5SubscriptionDashboardRequestData != undefined ||
      this.globalvar?.top5SubscriptionDashboardRequestData == "undefined"
    ) {
      if (
        this.globalvar?.top5SubscriptionDashboardRequestData?.top5_request ==
        true
      ) {
        this.LoginByTop5SubcriptionRequest();
      }
    }
    // isLoginCounselor
    if (this.globalvar?.isLoginAsCounselor != undefined) {
      if (this.globalvar?.isLoginAsCounselor?.isLoginAsCounselor == true) {
        this.loginStudentAsCounselor();
      }
    }

    if (this.globalvar.isLoginFromDashboard != undefined) {
      if (this.globalvar.isLoginFromDashboard.isLoginFromDashboard == true) {
        this.loginfromDashboard();
      }
    }
  }

  ngOnInit() {
    this.globalvar.organizationLoaded.subscribe((resp) => {
      // if (resp) {
      this.basepath = this.globalvar.basepath;
      this.imageURL = this.globalvar.logoUrl;
      if (this.globalvar.basepath == "top5") {
        const formFilledId = this.globalvar.seFormFilledId;
        if (formFilledId != undefined && formFilledId != "") {
          this.isLoginModelShow = true;
          if (
            document.location.hostname == "tech.virtueanalytics.com" ||
            "localhost"
          ) {
            this.formlogin.controls["user"].setValue("techtop5");
            this.formlogin.controls["pass"].setValue("govirtue123");
            this.cdRef.detectChanges();
          }

          if (
            document.location.hostname == "app.virtueanalytics.com" ||
            document.location.hostname == "top5.virtueanalytics.com" ||
            document.location.hostname == "find.top5colleges.us" ||
            document.location.hostname == "app.top5colleges.us"
          ) {
            this.formlogin.controls["user"].setValue("apptop5");
            this.formlogin.controls["pass"].setValue("welcome@123");
          }
        } else {
          if (
            this.globalvar.userLoginDetails &&
            this.globalvar.userLoginDetails.username &&
            this.globalvar.userLoginDetails.password
          ) {
            if (
              document.location.hostname == "tech.virtueanalytics.com" ||
              "localhost"
            ) {
              this.setLoginForm(this.globalvar.userLoginDetails);
              // if (!this.globalvar.isLoading) {
              //   this.onURLLogin();
              // }
            }
            if (
              document.location.hostname == "app.virtueanalytics.com" ||
              document.location.hostname == "top5.virtueanalytics.com" ||
              document.location.hostname == "find.top5colleges.us" ||
              document.location.hostname == "app.top5colleges.us"
            ) {
              this.setLoginForm(this.globalvar.userLoginDetails);
              // if (!this.globalvar.isLoading) {
              //   this.onURLLogin();
              // }
            }
          }
        }
      }

      // }
    });
    if (this.globalvar.LoginShowPopup == false) {
      this.popupexpired = true;
    }
    // this.checkloginSession.sessionStatusSubject
    //   .pipe(take(1))
    //   .subscribe((isValid) => {
    //     if (!isValid) {
    //       console.log(isValid, "kdslkkkkkkkkkkkkkkkkkk");
    //       this.popupexpired = isValid;
    //       this.cdRef.detectChanges();
    //       // Show your popup or navigate to the login page
    //       // You can also pass additional information in the Subject if needed
    //     }
    //   });
  }
  setLoginForm(loginInfo: any) {
    if (loginInfo) {
      this.isLoginModelShow = true;
      let user = loginInfo;
      this.formlogin.controls["user"].setValue(user.username);
      this.formlogin.controls["pass"].setValue(user.password);
    }
  }

  login() {
    this.isLoginModelShow = !this.isLoginModelShow;
    this.isSignUpModelShow = false;
  }

  onLogin() {
    this.codehelp.resetUserInfoLogout();
    if (!this.formlogin.valid) {
      return;
    }
    const userName = this.formlogin.value.user;
    const userPassword = this.formlogin.value.pass;
    let formdata = {
      username: userName,
      password: userPassword,
    };
    this.IsLoadData = true;
    this.apiService.login(JSON.stringify(formdata)).then(
      (resp: LoginInfo) => {
        this.codehelp.setStoreValue("LoginInfo", JSON.stringify(resp));
        this.codehelp.setAuthToken(resp.accessToken);
        this.globalvar.loginToken = resp.accessToken;
        this.codehelp.setSessionStoreValue(
          "loginToken",
          this.globalvar.loginToken
        ); //Handle morethan one user login

        this.apiService.loggedInInfo().then((loggedUser) => {
          if (loggedUser) {
            //  let ServiceUrlProviderId = this.codehelp.getProviderID();
            this.codehelp.setLoggedUserDetail(JSON.stringify(loggedUser));
            this.apiService
              .getUesrProfileData(loggedUser?.mappedTo.id)
              .then((userProfile) => {
                this.codehelp.setUserProfile(JSON.stringify(userProfile));
                // if (ServiceUrlProviderId == loggedUser?.orgRef?.id) {
                this.erroeMsg = "";
                this.isLoginModelShow = !this.isLoginModelShow;
                this.codehelp.setStoreValue("LoginUserFrom", "UserLogin");
                this.codehelp.setStoreValue(
                  "LoginSessionHoure",
                  resp.expireOnTime
                );

                this.globalvar.loadOrganization(false, false, true);
                this.globalvar.change(1);
                this.router.navigate(["/home/steps/1"]);
                // this.globalvar.isNotOrganizationLoading(false);
                // this.router.navigate([this.globalvar.basepath + "/home/steps/0",]);
              });
            let loginIfo = JSON.parse(this.codehelp.getStoreValue("LoginInfo"));
            if (loginIfo?.showTutorial == true) {
              this.dialogMailme = this.dialogService.open<any>(
                new PolymorpheusComponent(
                  DemoUserIntroComponent,
                  this.injector
                ),
                {
                  data: {},
                  dismissible: false,
                  size: "l",
                }
              );
              this.dialogMailme.subscribe({
                next: (data) => {},
              });
            }
          }
        });
      },
      (error) => {
        if (error.status == "500" || error.status) {
          this.notificatioService.showNotification(
            "Please enter valid username and password.",
            "Invalid User",
            true,
            "warning"
          );
          this.IsLoadData = false;
        }
      }
    );
  }
  private dialogMailme = this.dialogService.open<any>(
    new PolymorpheusComponent(DemoUserIntroComponent, this.injector),
    {
      data: {},
      dismissible: true,
      closeable: false,
      label: "",
      size: "s",
    }
  );

  loginStudentAsCounselor() {
    this.codehelp.setStoreValue(
      "LoginInfo",
      JSON.stringify(this.globalvar.isLoginAsCounselor.TokenAccess)
    );

    this.codehelp.setAuthToken(
      this.globalvar.isLoginAsCounselor.TokenAccess.accessToken
    );
    this.globalvar.loginToken =
      this.globalvar.isLoginAsCounselor.TokenAccess.accessToken;
    this.codehelp.setSessionStoreValue("loginToken", this.globalvar.loginToken); //Handle morethan one user login
    this.apiService.loggedInInfo().then((loggedUser) => {
      if (loggedUser) {
        //  let ServiceUrlProviderId = this.codehelp.getProviderID();
        this.codehelp.setLoggedUserDetail(JSON.stringify(loggedUser));
        this.apiService
          .getUesrProfileData(loggedUser?.mappedTo.id)
          .then((userProfile) => {
            this.codehelp.setUserProfile(JSON.stringify(userProfile));
            // if (ServiceUrlProviderId == loggedUser?.orgRef?.id) {
            this.erroeMsg = "";
            this.codehelp.setStoreValue(
              "LoginProviderId",
              loggedUser?.orgRef?.id
            );
            this.isLoginModelShow = !this.isLoginModelShow;

            this.codehelp.setStoreValue(
              "LoginUserFrom",
              "StudentLoginAsCounselor"
            );
            this.globalvar.loadOrganization(false, false, true);
            this.globalvar.change(1);
            this.router.navigate(["/home/steps/1"]);

            // this.globalvar.isNotOrganizationLoading(false);

            // this.router.navigate([this.globalvar.basepath + "/home/steps/0",]);
          });
      }
    });
  }
  loginfromDashboard() {
    this.codehelp.setStoreValue(
      "LoginInfo",
      JSON.stringify(this.globalvar.isLoginFromDashboard.accessToken)
    );

    this.codehelp.setAuthToken(
      this.globalvar.isLoginFromDashboard?.accessToken
    );
    this.globalvar.loginToken =
      this.globalvar.isLoginFromDashboard?.accessToken;
    this.codehelp.setSessionStoreValue("loginToken", this.globalvar.loginToken); //Handle morethan one user login
    this.apiService.loggedInInfo().then((loggedUser) => {
      if (loggedUser) {
        //  let ServiceUrlProviderId = this.codehelp.getProviderID();
        this.codehelp.setLoggedUserDetail(JSON.stringify(loggedUser));
        this.apiService
          .getUesrProfileData(loggedUser?.mappedTo.id)
          .then((userProfile) => {
            this.codehelp.setUserProfile(JSON.stringify(userProfile));
            // if (ServiceUrlProviderId == loggedUser?.orgRef?.id) {
            this.erroeMsg = "";
            this.codehelp.setStoreValue(
              "LoginProviderId",
              loggedUser?.orgRef?.id
            );

            this.codehelp.setStoreValue("LoginUserFrom", "LoginFromDashboard");
            this.globalvar.loadOrganization(false, false, true);
            this.globalvar.change(1);
            this.router.navigate(["/home/steps/1"]);

            // this.globalvar.isNotOrganizationLoading(false);

            // this.router.navigate([this.globalvar.basepath + "/home/steps/0",]);
          });
      }
    });
  }

  onURLLogin() {
    this.codehelp.resetUserInfoLogout();
    if (!this.formlogin.valid) {
      return;
    }
    const userName = this.formlogin.value.user;
    const userPassword = this.formlogin.value.pass;
    let formdata = {
      username: userName,
      password: userPassword,
    };
    this.IsLoadData = true;
    this.apiService.login(JSON.stringify(formdata)).then(
      (resp: LoginInfo) => {
        this.codehelp.setStoreValue("LoginInfo", JSON.stringify(resp));
        this.codehelp.setAuthToken(resp.accessToken);
        this.globalvar.loginToken = resp.accessToken;
        this.codehelp.setSessionStoreValue(
          "loginToken",
          this.globalvar.loginToken
        ); //Handle morethan one user login

        this.apiService.loggedInInfo().then((loggedUser) => {
          if (loggedUser) {
            this.codehelp.setLoggedUserDetail(JSON.stringify(loggedUser));
            this.apiService
              .getUesrProfileData(loggedUser?.mappedTo.id)
              .then((userProfile) => {
                this.codehelp.setUserProfile(JSON.stringify(userProfile));
                this.erroeMsg = "";
                this.isLoginModelShow = !this.isLoginModelShow;

                this.codehelp.setStoreValue("LoginUserFrom", "UserLogin");
                this.globalvar.loadOrganization(false, false, true);
                this.globalvar.change(1);
                this.router.navigate(["/home/steps/1"]);
              });
          }
        });
      },
      (error) => {
        if (error.status == "500" || error.status) {
          // this.notificatioService.showNotification(
          //   "Please enter valid username and password.",
          //   "Invalid User",
          //   true,
          //   "warning"
          // );
          this.IsLoadData = false;
        }
      }
    );
  }

  LoginByTop5SubcriptionRequest() {
    this.codehelp.setDefaultAuthToken();
    this.codehelp.setStoreValue("LoginUserFrom", "UserLogin");
    this.globalvar.change(2);
    this.router.navigate(["/home/steps/7"]);
    this.globalvar.loadOrganization(false, false, true);
    this.IsLoadData = false;
  }

  demoLink() {
    // let demoLink = "https://calendly.com/virtueanalytics/30min";
    // let demoLink = "https://outlook.office.com/bookwithme/?%2fjatin&anonymous";
    let demoLink = "https://link.virtueanalytics.com/jatin";
    window.open(demoLink, "_blank");
  }
  forgetPassword() {
    let redirectURL = "";
    const queryParams = { couponCode: "ResetPassword", org: "top5" };
    const queryString = this.serializeQueryParams(queryParams);
    if (
      window.location.hostname == "tech.virtueanalytics.com" ||
      window.location.hostname == "localhost"
    ) {
      redirectURL =
        "https://tech.virtueanalytics.com/top5App/home/signUp/counselor?" +
        queryString;
    }
    window.open(redirectURL, "_blank");
  }

  privacypolicy() {
    // let demoLink = "https://calendly.com/virtueanalytics/30min";
    // let demoLink = "https://outlook.office.com/bookwithme/?%2fjatin&anonymous";
    let privacypolicyLink = "https://www.top5colleges.us/privacy-policy/";
    window.open(privacypolicyLink, "_blank");
  }
  private opennote = this.dialogService.open<any>(
    new PolymorpheusComponent(ResultNotepopupComponent, this.injector),
    {
      dismissible: false,
      label: "",
      // size: "l",
    }
  );

  signupredirect(value: number) {
    let redirectURL = "";
    // if (value == 1) {
    //   this.router.navigate(["home/signUp/counselor"], { queryParams });
    // } else ={
    //   this.router.navigate(["/home/student"]);
    //   window.open(redirectURL, "_blank");
    // }
    const queryParams = { couponCode: "withoutCoupon", org: "top5" };
    const queryString = this.serializeQueryParams(queryParams);
    if (
      window.location.hostname == "tech.virtueanalytics.com" ||
      window.location.hostname == "localhost"
    ) {
      if (value == 1) {
        redirectURL =
          "https://tech.virtueanalytics.com/top5App/home/signUp/counselor?" +
          queryString;
      } else {
        redirectURL =
          "https://tech.virtueanalytics.com/top5App/home/student?" +
          queryString;
      }
    } else {
      if (value == 1) {
        redirectURL =
          "https://app.virtueanalytics.com/top5/home/signUp/counselor?" +
          queryString;
      } else {
        redirectURL =
          "https://app.virtueanalytics.com/top5/home/student?" + queryString;
      }
    }
    //   window.location.href =hostname;

    window.open(redirectURL, "_blank");
  }

  // signupredirect(value: number) {
  //   let redirectURL = "";
  //   // if (value == 1) {
  //   //   this.router.navigate(["home/signUp/counselor"], { queryParams });
  //   // } else ={
  //   //   this.router.navigate(["/home/student"]);
  //   //   window.open(redirectURL, "_blank");
  //   // }
  //   const queryParams = { couponCode: "withoutCoupon", org: "top5" };
  //   const queryString = this.serializeQueryParams(queryParams);
  //   if (
  //     window.location.hostname == "tech.virtueanalytics.com" ||
  //     window.location.hostname == "localhost"
  //   ) {
  //     if (value == 1) {
  //       redirectURL =
  //         "https://tech.virtueanalytics.com/top5App/home/signUp/counselor?" +
  //         queryString;
  //     } else {
  //       redirectURL =
  //         "https://tech.virtueanalytics.com/top5App/home/student?" +
  //         queryString;
  //     }
  //   } else {
  //     if (value == 1) {
  //       redirectURL =
  //         "https://app.virtueanalytics.com/top5/home/signUp/counselor?" +
  //         queryString;
  //     } else {
  //       redirectURL =
  //         "https://app.virtueanalytics.com/top5/home/student?" + queryString;
  //     }
  //   }
  //   //   window.location.href =hostname;

  //   window.open(redirectURL, "_blank");
  // }
  private serializeQueryParams(params: any): string {
    return Object.keys(params)
      .map((key) => key + "=" + params[key])
      .join("&");
  }
  signupshowpopup: boolean = false;
  signupshow() {
    this.signupshowpopup = !this.signupshowpopup;
  }
  closealert() {
    if (!this.globalvar.LoginShowPopup) {
      this.popupexpired = false;
      this.globalvar.LoginShowPopup = true;
    }
    this.popupexpired = false;
  }
}
